import "./Password.less";

import React, { PureComponent } from "react";
import { translate } from "react-i18next";
import classnames from "classnames";

class Password extends PureComponent {
	state = {
		password: "",
		passwordCheck: "",
		passwordMatch: undefined
	};

	render() {
		const t = this.props.t;
		const inputClassnames = classnames({ invalid: this.arePasswordsMatch() === false });

		return (
			<React.Fragment>
				<input type="password" className={inputClassnames} placeholder={t("password")} value={this.state.password} onChange={this.handlePasswordChange} onBlur={this.handlePasswordBlur} />
				<input type="password" className={inputClassnames} placeholder={t("passwordCheck")} value={this.state.passwordCheck} onChange={this.handlePasswordCheckChange} onBlur={this.handlePasswordBlur} />
				{
					this.arePasswordsMatch() === false &&
					<div className="error-holder">
						<p className="error">{t("passwordError")}</p>
					</div>
				}
			</React.Fragment>
		);
	}

	arePasswordsMatch() {
		return this.state.passwordMatch;
	}

	handlePasswordChange = event => {
		this.setState({ password: event.target.value });
	};

	handlePasswordCheckChange = event => {
		this.setState({ passwordCheck: event.target.value });
	};

	handlePasswordBlur = event => {
		if (this.state.password !== "" && this.state.passwordCheck !== "") {
			const match = this.state.password === this.state.passwordCheck;
			this.setState({ passwordMatch: match });
			match && this.props.onChange && this.props.onChange(this.state.password);
		} else {
			this.setState({ passwordMatch: undefined });
			this.props.onChange && this.props.onChange(undefined);
		}
	};
}

export default translate("password")(Password);



// WEBPACK FOOTER //
// ./src/components/Password/Password.js